/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class CustomerApi {
    static getInstance() {
        if (!this.instance) this.instance = new CustomerApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取客户列表
    async getCustomerList (app_id){
        let url = `/api/v1/page/dict/tree?app_id=${app_id}&dict_type=0`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 导出
    async exportCustomer (id){
        let url = `/api/v1/page/dict/export?customer_id=${id}`
        let result = await this.getData(url,{},'GET','application/octet-stream')
        return result
    }

}

export {
    CustomerApi
}